<template>
  <section>
    <div class="tip" style="margin: 0 0 0 20px">* 项目基本资料</div>
    <!-- <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input size="small" :disabled="true" placeholder="项目编号将由系统自动生成" v-model="form.number"></el-input>
        </el-form-item>
      </el-col>
    </div> -->
    <el-form-item label="申报单位">
      <el-input
        size="small"
        :disabled="true"
        v-model="userData.department.split('/')[0]"
      ></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input
            size="small"
            :disabled="true"
            v-model="userData.name"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式">
          <el-input
            size="small"
            :disabled="true"
            v-model="userData.mobile"
          ></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目组">
          <el-select
            @change="forceUpdate"
            size="small"
            class="organization-select"
            v-model="form.teamId"
            placeholder="请选择项目组"
          >
            <el-option
              v-for="item in teamArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <!-- <router-link to="/Project/Team" style="margin-top:7px;display:inline-block;margin-left:15px;text-decoration: underline;">点击新建项目组</router-link> -->
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="23">
        <el-form-item label="是否子项目">
          <el-row>
            <el-col :span="6">
              <el-select
                @change="forceUpdate"
                size="small"
                v-model="form.level"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in levelArr"
                  :key="item.level"
                  :label="item.name"
                  :value="item.level"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="16">
              <el-select
                @change="forceUpdate"
                class="full"
                size="small"
                filterable
                v-if="form.level == 1"
                v-model="form.parentProjectId"
                placeholder="选择已有父项目"
              >
                <el-option
                  v-for="item in projectArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear" v-if="form.level == 1">
      <el-col :span="10">
        <el-form-item label="子项目类型">
          <el-input
            size="small"
            v-model="form.ctype"
            placeholder="请输入子项目类型"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="14">
        <div class="tip">
          请输入子项目所属类型，如设计、监理、测绘、清淤等（2-6个字为佳）。
        </div>
      </el-col>
    </div>

    <el-form-item class="underline-label" label="已线下通过该审批">
      <el-radio v-model="form.underLine" label="1">是</el-radio>
      <el-radio v-model="form.underLine" label="0">否</el-radio>
      <p
        class="tip"
        v-if="form.underLine == '1'"
        style="padding: 0 10px; border: 1px #d93c37 solid"
      >
        *已线下通过的审批须在附件中上传原始审批文件或三重一大会议纪要等相关证明文件，方便领导批阅。
      </p>
    </el-form-item>
    <div class="clear">
      <el-col :span="16">
        <el-form-item label="项目名称">
          <el-input
            size="small"
            v-model="form.name"
            placeholder="请输入项目名称"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="是否需要招标">
          <el-radio v-model="form.iszb" label="1">是</el-radio>
          <el-radio v-model="form.iszb" label="0">否</el-radio>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="项目介绍">
      <el-input
        type="textarea"
        placeholder="需求工程项目情况介绍（需求情况、目的、要求及意义）"
        :autosize="{ minRows: 3, maxRows: 6 }"
        size="small"
        v-model="form.intro"
      ></el-input>
    </el-form-item>

    <div class="tip" style="margin: 20px 0 0 30px">* 资金安排</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="估算投资(元)">
          <el-input size="small" type="number" v-model="form.xmgs"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="总工期(天)">
          <el-input size="small" type="number" v-model="form.xmgq"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="资金来源">
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 6 }"
        size="small"
        v-model="form.zjly"
      ></el-input>
    </el-form-item>

    <div class="tip" style="margin: 20px 0 0 30px">* 前期工作及施工要求</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="是否需要委托设计" label-width="175px">
          <el-radio-group v-model="form.iswtsj">
            <el-radio-button :label="true">是</el-radio-button>
            <el-radio-button :label="false">否</el-radio-button>
          </el-radio-group>
          <!-- <el-input size="small" v-model="form.nwtsjdw"></el-input> -->
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          v-if="form.iswtsj"
          label="设计单位发包方式"
          label-width="175px"
        >
          <el-radio-group v-model="form.sjdwfbfs">
            <el-radio-button label="中介超市">中介超市</el-radio-button>
            <el-radio-button label="公开招标">公开招标</el-radio-button>
          </el-radio-group>
          <!-- <el-input size="small" v-model="form.pzsjdw"></el-input> -->
        </el-form-item>
      </el-col>
    </div>
    <!-- <div class="clear">
      <el-col :span="18">
        <el-form-item label="建议施工管理单位" label-width="175px">
          <el-input size="small" v-model="form.jysgdw"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="批准的施工管理单位" label-width="175px">
          <el-input size="small" v-model="form.pzsgdw"></el-input>
        </el-form-item>
      </el-col>
    </div> -->
    <div
      class="clear tip"
      style="
        line-height: 1.6;
        padding: 5px 8px;
        margin: 20px 20px 10px;
        font-size: 12px;
        border: 1px #ff7000 solid;
        border-radius: 5px;
        color: #ff7000;
      "
    >
      <p>以下计划时间是3选1的：</p>
      <p>已完成但无确定时间，选择已完成；</p>
      <p>无须进行的步骤，选无；</p>
      <p>其他有确定时间，无论是否已完成，都请直接选择日期即可。</p>
    </div>
    <div class="clear">
      <el-col :span="20">
        <el-form-item label="初步设计计划评审时间" label-width="175px">
          <el-col :span="6">
            <el-radio
              label="-1"
              v-if="
                !operationType || (operationType == 'show' && jhpssj_type == -1)
              "
              v-model="jhpssj_type"
              >已完成</el-radio
            >
            <el-radio
              label="-2"
              v-if="
                !operationType || (operationType == 'show' && jhpssj_type == -2)
              "
              v-model="jhpssj_type"
              >无</el-radio
            >
          </el-col>
          <el-col
            :span="14"
            v-if="
              !operationType ||
              (operationType == 'show' &&
                jhpssj_type != -1 &&
                jhpssj_type != -2)
            "
          >
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="form.jhpssj"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
      <el-col :span="20">
        <el-form-item label="计划概算批复时间" label-width="175px">
          <el-col :span="6">
            <el-radio
              label="-1"
              v-if="
                !operationType ||
                (operationType == 'show' && jhgspfsj_type == -1)
              "
              v-model="jhgspfsj_type"
              >已完成</el-radio
            >
            <el-radio
              label="-2"
              v-if="
                !operationType ||
                (operationType == 'show' && jhgspfsj_type == -2)
              "
              v-model="jhgspfsj_type"
              >无</el-radio
            >
          </el-col>
          <el-col
            :span="14"
            v-if="
              !operationType ||
              (operationType == 'show' &&
                jhgspfsj_type != -1 &&
                jhgspfsj_type != -2)
            "
          >
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="form.jhgspfsj"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="20">
        <el-form-item label="计划招标控制价备案时间" label-width="175px">
          <el-col :span="6">
            <el-radio
              label="-1"
              v-if="
                !operationType || (operationType == 'show' && zbbasj_type == -1)
              "
              v-model="zbbasj_type"
              >已完成</el-radio
            >
            <el-radio
              label="-2"
              v-if="
                !operationType || (operationType == 'show' && zbbasj_type == -2)
              "
              v-model="zbbasj_type"
              >无</el-radio
            >
          </el-col>
          <el-col
            :span="14"
            v-if="
              !operationType ||
              (operationType == 'show' &&
                zbbasj_type != -1 &&
                zbbasj_type != -2)
            "
          >
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="form.zbbasj"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
      <el-col :span="20">
        <el-form-item label="计划施工招标完成时间" label-width="175px">
          <el-col :span="6">
            <el-radio
              label="-1"
              v-if="
                !operationType ||
                (operationType == 'show' && sgzbwcsj_type == -1)
              "
              v-model="sgzbwcsj_type"
              >已完成</el-radio
            >
            <el-radio
              label="-2"
              v-if="
                !operationType ||
                (operationType == 'show' && sgzbwcsj_type == -2)
              "
              v-model="sgzbwcsj_type"
              >无</el-radio
            >
          </el-col>
          <el-col
            :span="14"
            v-if="
              !operationType ||
              (operationType == 'show' &&
                sgzbwcsj_type != -1 &&
                sgzbwcsj_type != -2)
            "
          >
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="form.sgzbwcsj"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="20">
        <el-form-item label="计划材料完成招标时间" label-width="175px">
          <el-col :span="6">
            <el-radio
              label="-1"
              v-if="
                !operationType ||
                (operationType == 'show' && clwczbsj_type == -1)
              "
              v-model="clwczbsj_type"
              >已完成</el-radio
            >
            <el-radio
              label="-2"
              v-if="
                !operationType ||
                (operationType == 'show' && clwczbsj_type == -2)
              "
              v-model="clwczbsj_type"
              >无</el-radio
            >
          </el-col>
          <el-col
            :span="14"
            v-if="
              !operationType ||
              (operationType == 'show' &&
                clwczbsj_type != -1 &&
                clwczbsj_type != -2)
            "
          >
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="form.clwczbsj"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
      <el-col :span="20">
        <el-form-item label="计划设备完成招标时间" label-width="175px">
          <el-col :span="6">
            <el-radio
              label="-1"
              v-if="
                !operationType ||
                (operationType == 'show' && sbwczbsj_type == -1)
              "
              v-model="sbwczbsj_type"
              >已完成</el-radio
            >
            <el-radio
              label="-2"
              v-if="
                !operationType ||
                (operationType == 'show' && sbwczbsj_type == -2)
              "
              v-model="sbwczbsj_type"
              >无</el-radio
            >
          </el-col>
          <el-col
            :span="14"
            v-if="
              !operationType ||
              (operationType == 'show' &&
                sbwczbsj_type != -1 &&
                sbwczbsj_type != -2)
            "
          >
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="form.sbwczbsj"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="20">
        <el-form-item label="计划开工时间" label-width="175px">
          <el-col :span="6">
            <el-radio
              label="-1"
              v-if="
                !operationType || (operationType == 'show' && jhkgsj_type == -1)
              "
              v-model="jhkgsj_type"
              >已完成</el-radio
            >
            <el-radio
              label="-2"
              v-if="
                !operationType || (operationType == 'show' && jhkgsj_type == -2)
              "
              v-model="jhkgsj_type"
              >无</el-radio
            >
          </el-col>
          <el-col
            :span="14"
            v-if="
              !operationType ||
              (operationType == 'show' &&
                jhkgsj_type != -1 &&
                jhkgsj_type != -2)
            "
          >
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="form.jhkgsj"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
      <el-col :span="20">
        <el-form-item label="计划完工时间" label-width="175px">
          <el-col :span="6">
            <el-radio
              label="-1"
              v-if="
                !operationType || (operationType == 'show' && jhwgsj_type == -1)
              "
              v-model="jhwgsj_type"
              >已完成</el-radio
            >
            <el-radio
              label="-2"
              v-if="
                !operationType || (operationType == 'show' && jhwgsj_type == -2)
              "
              v-model="jhwgsj_type"
              >无</el-radio
            >
          </el-col>
          <el-col
            :span="14"
            v-if="
              !operationType ||
              (operationType == 'show' &&
                jhwgsj_type != -1 &&
                jhwgsj_type != -2)
            "
          >
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="form.jhwgsj"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
      </el-col>
    </div>
  </section>
</template>

<script>
export default {
  props: ["formByFather", "userData", "teamArr", "projectArr", "operationType"],
  data() {
    return {
      form: {},

      updateType: true,
      jhpssj_type: "",
      jhgspfsj_type: "",
      zbbasj_type: "",
      sgzbwcsj_type: "",
      clwczbsj_type: "",
      sbwczbsj_type: "",
      jhkgsj_type: "",
      jhwgsj_type: "",

      levelArr: [
        {
          level: 0,
          name: "父级项目",
        },
        {
          level: 1,
          name: "子级项目",
        },
      ],
    };
  },
  mounted() {
    this.setFromData();
  },
  methods: {
    // select刷新view
    forceUpdate(item) {
      this.$forceUpdate();
    },
    setFromData() {
      this.form = this.formByFather;
      console.log(this.form);

      this.form.depId = this.userData.secDepIds.split(",")[0];
      this.form.leaderId = this.userData.id;
    },
    setFormSjType() {
      // 设置默认选中已完成/无
      this.jhpssj_type = this.form.jhpssj ? this.form.jhpssj : this.jhpssj_type;
      this.jhgspfsj_type = this.form.jhgspfsj
        ? this.form.jhgspfsj
        : this.jhgspfsj_type;
      this.zbbasj_type = this.form.zbbasj ? this.form.zbbasj : this.zbbasj_type;
      this.sgzbwcsj_type = this.form.sgzbwcsj
        ? this.form.sgzbwcsj
        : this.sgzbwcsj_type;
      this.clwczbsj_type = this.form.clwczbsj
        ? this.form.clwczbsj
        : this.clwczbsj_type;
      this.sbwczbsj_type = this.form.sbwczbsj
        ? this.form.sbwczbsj
        : this.sbwczbsj_type;
      this.jhkgsj_type = this.form.jhkgsj ? this.form.jhkgsj : this.jhkgsj_type;
      this.jhwgsj_type = this.form.jhwgsj ? this.form.jhwgsj : this.jhwgsj_type;
    },
    setTypeToForm() {
      if (this.operationType == "show") {
        return;
      }

      this.updateType = false;
      setTimeout(() => {
        this.updateType = true;
      }, 100);
      if (this.jhpssj_type == "-1" || this.jhpssj_type == "-2") {
        this.form.jhpssj = "";
      }
      if (this.jhgspfsj_type == "-1" || this.jhgspfsj_type == "-2") {
        this.form.jhgspfsj = "";
      }
      if (this.zbbasj_type == "-1" || this.zbbasj_type == "-2") {
        this.form.zbbasj = "";
      }
      if (this.sgzbwcsj_type == "-1" || this.sgzbwcsj_type == "-2") {
        this.form.sgzbwcsj = "";
      }
      if (this.clwczbsj_type == "-1" || this.clwczbsj_type == "-2") {
        this.form.clwczbsj = "";
      }
      if (this.sbwczbsj_type == "-1" || this.sbwczbsj_type == "-2") {
        this.form.sbwczbsj = "";
      }
      if (this.jhkgsj_type == "-1" || this.jhkgsj_type == "-2") {
        this.form.jhkgsj = "";
      }
      if (this.jhwgsj_type == "-1" || this.jhwgsj_type == "-2") {
        this.form.jhwgsj = "";
      }
    },
    getFromData() {
      let _form = JSON.parse(JSON.stringify(this.form));
      _form.jhpssj = !this.form.jhpssj ? this.jhpssj_type : this.form.jhpssj;
      _form.jhgspfsj = !this.form.jhgspfsj
        ? this.jhgspfsj_type
        : this.form.jhgspfsj;
      _form.zbbasj = !this.form.zbbasj ? this.zbbasj_type : this.form.zbbasj;
      _form.sgzbwcsj = !this.form.sgzbwcsj
        ? this.sgzbwcsj_type
        : this.form.sgzbwcsj;
      _form.clwczbsj = !this.form.clwczbsj
        ? this.clwczbsj_type
        : this.form.clwczbsj;
      _form.sbwczbsj = !this.form.sbwczbsj
        ? this.sbwczbsj_type
        : this.form.sbwczbsj;
      _form.jhkgsj = !this.form.jhkgsj ? this.jhkgsj_type : this.form.jhkgsj;
      _form.jhwgsj = !this.form.jhwgsj ? this.jhwgsj_type : this.form.jhwgsj;

      return _form;
    },
  },
  watch: {
    jhpssj_type: "setTypeToForm",
    jhgspfsj_type: "setTypeToForm",
    zbbasj_type: "setTypeToForm",
    sgzbwcsj_type: "setTypeToForm",
    clwczbsj_type: "setTypeToForm",
    sbwczbsj_type: "setTypeToForm",
    jhkgsj_type: "setTypeToForm",
    jhwgsj_type: "setTypeToForm",
    form: {
      handler(newName, oldName) {
        // console.log(this.form.jhwgsj)
        if (this.updateType) {
          this.setFormSjType();
        }
      },
      deep: true,
    },
    formByFather() {
      this.setFromData();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/form/create1.vue